import React from 'react';
import {findMetric} from '../services/metricsSvc'

export const BodyMetrics = (props) => {
  const waist = findMetric('waist_belt', props.measurements)
  const height = findMetric('height', props.measurements)
  const chest = findMetric('chest_circ', props.measurements)
 
  return (
    <dl className="body-info-list">
        <dt>Height</dt>
        <dd>{height}</dd>
        
        <dt>Waist</dt>
        <dd>{waist}</dd>

        <dt>Chest</dt>
        <dd>{chest}</dd>
    </dl>
      
    
  );
};